import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentCanDeactivate } from '@app/can-deactivate.guard';
import { Profile } from '@app/models/profile.model';
import { KirokuMenu, RecordField } from '@app/models/record.model';
import { Staff } from '@app/models/staff.model';
import { AccesslogService } from '@app/services/accesslog.service';
import { ApiService } from '@app/services/api.service';
import { DialogService } from '@app/services/dialog.service';
import { MessageService } from '@app/services/message.service';
import { RecordService } from '@app/services/record.service';
import { ScheduleService } from '@app/services/schedule.service';
import { AuthSelectors } from '@app/store/auth/auth.selectors';
import { Store } from '@ngxs/store';
import { LibNoteService } from '@care-connect-japan/ckweblib';
import { WebviewService } from '@app/services/webview.service';
import { NoteBlobService } from '@app/services/noteblob.service';
import { TriggerHistory } from '@app/store/schedule/schedule.classes';
import { AccessLog } from '@app/shared/enum/record-list.enum';
import { catchError } from 'rxjs';
import { OfficeService } from '@app/services/office.service';
import { SetStaffInTeamList } from '@app/store/data/data.classes';
import { UserService } from '@app/services/dai.service';
import { StorageEnum } from '@app/shared/enum/storage';

@Component({
  selector: 'app-record-edit',
  templateUrl: './record-edit.component.html',
  styleUrls: ['./record-edit.component.scss'],
})
export class RecordEditComponent implements OnInit, ComponentCanDeactivate, OnDestroy {
  staffList!: Staff[];
  record!: RecordField;
  form!: FormGroup;
  disabled!: boolean;
  duplicate!: boolean;
  profile!: Profile | null;
  isSubmit = false;
  historyBackWard = () => history.back();
  private canLeave: boolean = false;

  get userList() {
    return this.daiService.userList;
  }

  get user() {
    const objcd = this.record.objcd;
    if (!objcd) return;
    return this.userList.find(x => x.daicd === objcd);
  }

  get userName() {
    if (!this.user) return '';
    return (this.user.family || '') + (this.user.given || '')
  }

  get currentMenu(): string {
    return localStorage.getItem(StorageEnum.MENU_ITEM) || KirokuMenu.EMPTY;
  }

  // get isCasefile() {
  //   return this.currentMenu === MENU_KIDS.CASEFILE;
  // }

  constructor(
    public scheduleService: ScheduleService,
    private route: ActivatedRoute,
    private router: Router,
    private store: Store,
    private accesslog: AccesslogService,
    private message: MessageService,
    private dialog: DialogService,
    private daiService: UserService,
    private apiService: ApiService,
    private recordService: RecordService,
    private libNoteService: LibNoteService,
    private webviewService: WebviewService,
    private officeService: OfficeService,
    private noteblobService: NoteBlobService,
  ) {
    this.store.dispatch(new SetStaffInTeamList(this.officeService.officecd))
  }
  ngOnDestroy(): void {
    this.webviewService.kidsWarningBeforeChangePageIndicator(false);
  }

  ngOnInit(): void {
    this.profile = this.store.selectSnapshot(AuthSelectors.profile);
    this.webviewService.kidsWarningBeforeChangePageIndicator(true);
    const operation = this.route.snapshot.paramMap.get('operation');
    this.duplicate = operation === 'duplicate';

    this.route.data.subscribe((data) => {
      this.staffList = data['staffList'];
      this.disabled = data['disabled'];

      const { note } = data['record'];
      this.record = { ...note };

      this.form = this.recordService.setRecordForm(this.profile, this.record);
    });
  }

  canDeactivate() {
    return this.canLeave;
  }

  async onSubmit(): Promise<void> {
    try {
      this.isSubmit = true;
      const noteDatas = this.libNoteService.getNoteData();
      if (this.recordService.isValidationError(noteDatas)) return;
      const findNoteData = this.recordService.findNoteData(noteDatas);
      const getStaffName = this.scheduleService.getStaffName(this.staffList);
      const noteData = findNoteData(this.record);
      const noteid = this.duplicate ? undefined : this.record.noteid;
      const operation = this.recordService.getOperation(noteid);
      const note = {
        ...this.record,
        ...noteData,
        ...this.recordService.getFormValue(
          this.form.value,
          getStaffName(this.record)
        ),
        noteid,
        dataV2Contents: undefined,
      };
      const displayName = this.accesslog.getKidsDisplayName(AccessLog.RECORD_EDIT);
      const _payload = await this.noteblobService.createNoteBlobPayload([{ operation, note, displayName }], this.duplicate);
      this.apiService
        .setNoteList(_payload).pipe(catchError((_, c) => { this.isSubmit = false; return c }))
        .subscribe((res: any) => {
          const errorList = res
            .filter((item: any) => !!item.error)
            .map((item: any) => this.message.getErrorMessage(item.error!));

          if (errorList.length > 0) {
            this.dialog.message(errorList.join('\n'));
            this.isSubmit = false;
          } else if (res.length > 0 && errorList.length !== res.length) {
            this.dialog.successAlert('記録を保存しました').afterClosed().subscribe(async () => {
              this.canLeave = true;
              this.webviewService.kidsWarningBeforeChangePageIndicator(false);
              this.router.navigate([{ outlets: { edit: null } }], { replaceUrl: true, queryParamsHandling: "preserve" }).then(() => {
                this.router.navigate(['home/list'], { replaceUrl: true, queryParamsHandling: "preserve" });
                this.store.dispatch(new TriggerHistory());
              });
              // if(this.isCasefile) {
              //   history.go(-2);
              //   this.store.dispatch(new TriggerHistory());
              //   // this.router.navigate(
              //   //   [{ outlets: { primary: ['home', 'casefile'], edit: null } }],
              //   //   { replaceUrl: true, queryParamsHandling: 'preserve' }
              //   // ).then(() => {
              //   //   this.store.dispatch(new TriggerHistory());
              //   // });
              // } else {
              //   this.router.navigate([{ outlets: { edit: null } }], { replaceUrl: true, queryParamsHandling: "preserve" }).then(() => {
              //     this.router.navigate(['home/list'], { replaceUrl: true, queryParamsHandling: "preserve" });
              //     this.store.dispatch(new TriggerHistory());
              //   });
              // }
            })
          }
        });
    } catch (error) {
      this.isSubmit = false;
    }

  }


  protected backPage(path: string) {
    return path;
  }
}
